import { NavLink, Outlet } from 'react-router-dom';

const tabs = [
  { to: '/usuarios', label: 'Lista de Contas', end: true },
  { to: '/usuarios/aprovacoes', label: 'Aprovações de Conta', end: false },
  { to: '/usuarios/rejeitadas', label: 'Rejeitadas', end: false },
];

export function UsersLayout() {
  return (
    <div className="flex flex-col gap-6">
      <div>
        <h1 className="text-2xl font-display font-bold text-slate-900">Usuários</h1>
        <p className="text-slate-500 text-sm mt-1">Gerencie usuários e capacidades.</p>
      </div>

      <div className="border-b border-slate-200">
        <nav className="flex gap-1">
          {tabs.map((tab) => (
            <NavLink
              key={tab.to}
              to={tab.to}
              end={tab.end}
              className={({ isActive }) =>
                `px-4 py-2.5 text-sm font-medium border-b-2 transition-colors -mb-px ${
                  isActive
                    ? 'border-primary text-primary'
                    : 'border-transparent text-slate-500 hover:text-slate-700 hover:border-slate-300'
                }`
              }
            >
              {tab.label}
            </NavLink>
          ))}
        </nav>
      </div>

      <Outlet />
    </div>
  );
}
